import './struggles.style.sass';
import template from './struggles.tpl.pug';

class StrugglesController {
    /* @ngInject */
    constructor($state) {
        this.$state = $state;
        this.selectedOptions = [];
        this.options = [
            {
                id: 'debt',
                text: 'Getting out of debt',
                icon: 'wallet'
            },
            {
                id: 'unexpected',
                text: 'Covering unexpected expenses',
                icon: 'calendar'
            },
            {
                id: 'family',
                text: 'Managing family finances',
                icon: 'users'
            },
            {
                id: 'saving',
                text: 'Saving for bigger expenses',
                icon: 'note-add'
            },
            {
                id: 'retirement',
                text: 'Planning for retirement',
                icon: 'chart'
            }
        ];
    }

    toggleOption(option) {
        const index = this.selectedOptions.indexOf(option);
        if (index === -1) {
            this.selectedOptions.push(option);
        } else {
            this.selectedOptions.splice(index, 1);
        }
    }

    nextStep() {
        if (this.selectedOptions.length > 0) {
            this.onSubmit({
                questionKey: 'struggles',
                answer: this.selectedOptions.map((opt) => opt.id)
            });
            this.$state.go('conversion-quiz.tracking');
        }
    }
}

export default {
    template: template(),
    controller: StrugglesController,
    bindings: {
        onSubmit: '&'
    }
};



// WEBPACK FOOTER //
// ./src/presentation/scene/conversion-quiz/steps/struggles/struggles.cmpt.js